import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'aws-amplify/auth';
import { deleteAccount } from '../services/api';

export default function DeleteAccountSection() {
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmText, setConfirmText] = useState('');
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState('');

  const handleDelete = async () => {
    if (confirmText !== 'DELETE') return;
    setError('');
    setDeleting(true);
    try {
      await deleteAccount();
      try { await signOut(); } catch { /* user record already gone */ }
      navigate('/login', { replace: true });
    } catch (err) {
      setError(err?.data?.error || err?.message || 'Failed to delete account');
      setDeleting(false);
    }
  };

  return (
    <div className="card">
      <h3 className="section-title">Account</h3>

      {!showConfirm ? (
        <button
          onClick={() => setShowConfirm(true)}
          className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors w-full text-left min-h-[44px]"
        >
          <span aria-hidden="true" className="text-red-500">🗑️</span>
          <span className="text-sm font-medium text-red-600 dark:text-red-400">Delete Account</span>
        </button>
      ) : (
        <div className="space-y-3">
          <div className="p-3 bg-red-50 dark:bg-red-900/20 rounded-lg border border-red-200 dark:border-red-800">
            <p className="text-sm font-medium text-red-700 dark:text-red-400">
              This action is permanent and cannot be undone.
            </p>
            <p className="text-xs text-red-600 dark:text-red-400 mt-1">
              All your scores, profile, daily challenge entries, and power-up inventory will be permanently
              deleted. Active subscriptions must be cancelled separately through Stripe Customer Portal
              (web) or your App Store account (iOS).
            </p>
          </div>

          <div>
            <label className="block text-xs text-gray-500 dark:text-night-muted mb-1">
              Type <strong>DELETE</strong> to confirm
            </label>
            <input
              type="text"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              className="input-field"
              placeholder="DELETE"
              autoComplete="off"
            />
          </div>

          {error && <p className="text-xs text-red-500">{error}</p>}

          <div className="flex gap-2">
            <button
              type="button"
              onClick={handleDelete}
              disabled={confirmText !== 'DELETE' || deleting}
              className="btn-danger flex-1"
            >
              {deleting ? 'Deleting...' : 'Permanently Delete Account'}
            </button>
            <button
              type="button"
              disabled={deleting}
              onClick={() => { setShowConfirm(false); setConfirmText(''); setError(''); }}
              className="btn-secondary"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
